import {
  GUIDANCE_TARGET,
  type GuidanceTarget,
} from '@/core/guidance/constants';
import { canonicalizeShellPathname, shellPaths } from '@/core/router/app-paths';

/** Map shell paths to orientation tour targets. */
export function guidanceTargetForPath(
  path: string,
): GuidanceTarget | undefined {
  const clean = canonicalizeShellPathname(path);
  if (clean === shellPaths.home || clean.startsWith(`${shellPaths.home}/`)) {
    return GUIDANCE_TARGET.home;
  }
  if (
    clean === shellPaths.profiles ||
    clean.startsWith(`${shellPaths.profiles}/`)
  ) {
    return GUIDANCE_TARGET.profiles;
  }
  if (clean === shellPaths.leads || clean.startsWith(`${shellPaths.leads}/`)) {
    return GUIDANCE_TARGET.leads;
  }
  if (
    clean === shellPaths.moreProducts ||
    clean.startsWith(`${shellPaths.moreProducts}/`)
  ) {
    return GUIDANCE_TARGET.navProducts;
  }
  return undefined;
}

/**
 * Sidebar groups (e.g. Leads → All leads / Events) have no URL of their own;
 * anchor the tour on the group trigger via the first child that maps to one.
 */
export function guidanceTargetForNavGroup(
  childPaths: readonly string[],
): GuidanceTarget | undefined {
  for (const path of childPaths) {
    const target = guidanceTargetForPath(path);
    if (target) return target;
  }
  return undefined;
}
